var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Exclude, Expose, Type } from 'class-transformer';
import { IsDateString, IsIP, IsObject, IsOptional, IsString, IsUUID } from 'class-validator';
import { UserProfileDto } from './user.profile.dto.js';
export class ConsentDeclarationFullSizeDto {
    id;
    createdAt;
    updatedAt;
    consentVersion;
    ipAddress;
    user;
    userId;
}
__decorate([
    IsUUID(),
    Expose(),
    __metadata("design:type", String)
], ConsentDeclarationFullSizeDto.prototype, "id", void 0);
__decorate([
    IsDateString(),
    Exclude(),
    __metadata("design:type", Date)
], ConsentDeclarationFullSizeDto.prototype, "createdAt", void 0);
__decorate([
    IsDateString(),
    Exclude(),
    __metadata("design:type", Date)
], ConsentDeclarationFullSizeDto.prototype, "updatedAt", void 0);
__decorate([
    IsOptional(),
    IsString(),
    Expose(),
    __metadata("design:type", Object)
], ConsentDeclarationFullSizeDto.prototype, "consentVersion", void 0);
__decorate([
    IsOptional(),
    IsIP(),
    Exclude(),
    __metadata("design:type", Object)
], ConsentDeclarationFullSizeDto.prototype, "ipAddress", void 0);
__decorate([
    IsObject(),
    Type(() => UserProfileDto),
    Expose(),
    __metadata("design:type", Function)
], ConsentDeclarationFullSizeDto.prototype, "user", void 0);
__decorate([
    IsUUID(),
    Expose(),
    __metadata("design:type", String)
], ConsentDeclarationFullSizeDto.prototype, "userId", void 0);
//# sourceMappingURL=consentDeclaration.full-size.dto.js.map